import { DocumentPage } from "../../components/layout/DocumentPage";
import { PageHeader } from "../../components/layout/PageHeader";
import { Reveal } from "../../components/motion/Reveal";
import { profile } from "../../data/profile";
import styles from "./About.module.css";

const details = [
  [
    "전문 영역",
    "웹 프론트엔드 · 백엔드 API · 모바일 앱 · 외부 장비 연동",
  ],
  [
    "주요 기술",
    "React · Spring Framework · Node.js · Android · iOS · React Native · Git",
  ],
  ["개발 경력", profile.career],
  ["자격증", profile.certification],
  [
    "핵심 강점",
    "UI부터 API, 데이터베이스, 모바일 네이티브와 외부 장비 연동까지 전체 흐름을 직접 설계하고 구현합니다.",
  ],
] as const;

export function About() {
  return (
    <DocumentPage id="about" pageNumber={2}>
      <PageHeader
        eyebrow="02 / ABOUT"
        title={"웹·API·모바일·외부 장비를 연결하는 개발자입니다."}
        description="다양한 플랫폼과 기술을 연결해 실제 운영 가능한 서비스를 개발해 왔습니다."
        wideDescription
      />

      <Reveal className={styles.statement}>
        <p>
          <span>
            문제와 운영 환경에 맞는 기술을 선택하고,
          </span>
          <span>
            변경과 유지보수에 대응하기 쉬운 구조로 구현합니다.
          </span>
        </p>
      </Reveal>

      <div className={styles.details}>
        {details.map(([label, value], index) => (
          <Reveal
            key={label}
            delay={index * 0.05}
            className={`${styles.detail} ${
              label === "핵심 강점" ? styles.fullDetail : ""
            }`}
          >
            <span>{label}</span>
            <strong>{value}</strong>
          </Reveal>
        ))}

        <Reveal
          delay={0.3}
          className={`${styles.detail} ${styles.fullDetail}`}
        >
          <span>개발 원칙</span>
          <strong>
            책임을 명확히 분리하고, 문제 추적과 유지보수가 쉬운 구조를 만듭니다.
          </strong>
        </Reveal>
      </div>
    </DocumentPage>
  );
}